module.exports = __webpack_public_path__ + "static/media/long-arrow-alt-down.50b3cd31.svg";